import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthMyfileService } from '../services/auth.myfile.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private authService: AuthMyfileService,
        private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError((err: any) => {
                    if (err != undefined && err.error) {
                        if (err && err.status === 401 || err.status === 0) {
                            if (err.url && err.url.includes("badge-counts")) {
                                //Disable Auto Logout for "badge-counts fails to respond" error - while we get mongo up and running properly for client with to many un-indexed documents. 
                                console.error("Badge Counts call failed to load properly because of timeout.")
                            } else {
                                var url = this.router.routerState.snapshot.url;
                                if (url && url.indexOf("auth") <= 0) {
                                    // auto logout if 401 response returned from api and we are logged in
                                    this.authService.logout();
                                }
                            }
                        }
                    }
                    else if (typeof err === "string") {
                        console.log(`HTML Sytanx Error: ${err}`)
                    }
                    return throwError(err);
                }));
    }
}
